import React, { useState, useEffect } from "react";
import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";
import Logo from "../logo.png";
import axios from 'axios';
import { POPUP_PREFERENCES_URL } from './ApiDetails';

const InformationPopup = ({ isOpen, role, onClose }) => {
  const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);


  // Check localStorage to determine if the popup should be shown
  useEffect(() => {
    const hidePopup = localStorage.getItem('hidePopup');
    if (hidePopup === 'true') {
      onClose(role); // Close the popup if the user had previously opted out
    }
  }, [onClose, role]);

  const handleCheckboxChange = async (event) => {
    if (event.target.checked)
      localStorage.setItem('showdialogue', false);
    else {
      localStorage.removeItem('showdialogue');
    }
    setIsCheckboxChecked(event.target.checked);

    await axios.post(POPUP_PREFERENCES_URL, { IsCheckboxChecked: isCheckboxChecked });
  };

  const handleStartToMeet = () => {
    if (isCheckboxChecked) {
      localStorage.setItem('hidePopup', 'false'); // Save preference to localStorage
    } else {
      localStorage.setItem('hidePopup', 'false'); // Ensure false if not checked
    }
    onClose(role); // Close the popup when the button is clicked
  };

  const modalStyles = {
    position: "absolute",
    top: "50px",
    left: "50%",
    transform: "translateX(-50%)",
    width: window.innerWidth <= 765 ? "250px" : "900px",
    wordBreak: "break-word",
    padding: "20px",
    border: "1px solid #d9d7d7",
    borderRadius: "5px",
    boxSizing: "border-box",
    zIndex: 9999,
    backgroundColor: "#fff",
    overflow: "visible",
    height: window.innerWidth <= 768 ? "75vh" : "",
    overflowY: window.innerWidth <= 768 ? "scroll" : "",
    fontSize: window.innerWidth <= 425 ? "12px" : "",
  };
 

  const contentStyles = {
    textAlign: "left",
    color: "darkblue",
    paddingRight: "10px",
  };

  const overlayStyles = {
    backgroundColor: 'rgba(255, 255, 255, 0.7)',
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 9998,
    overflowY: 'auto',
  };

  const textCenter = {
    textAlign: "center",
  };

  const logoStyles = {
    marginBottom: "20px",
  };

  const boldText = {
    fontWeight: "bold",
    fontSize: window.innerWidth <= 425 ? "14px" : "",
  };

  const purpleText = {
    color: "#6f42c1",
  };

  const greenText = {
    color: "#28a745",
  };

  const sectionHeader = {
    ...boldText,
    marginTop: "20px",
    marginBottom: "10px",
  };

  const checkboxContainer = {
    marginTop: "20px",
    textAlign: "center",
  };

  const buttonStyles = {
    backgroundColor: "#007bff",
    color: "white",
    padding: window.innerWidth <= 768 ? "3px 8px" : "10px 20px",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    marginTop: "20px",
  };

  return (
    <Popup
      open={isOpen}
      onClose={onClose}
      modal
      contentStyle={modalStyles}
      overlayStyle={overlayStyles}
      closeOnDocumentClick={false}  // Prevents closing on outside click
    >
      <div style={contentStyles}>
        <div style={textCenter}>
          <img
            src={Logo}
            alt="Logo"
            width={window.innerWidth <= 768 ? "120" : "180"}
            height="68"
            style={logoStyles}
          />
        </div>
        <h5 style={boldText}>Welcome!</h5>
        <p>
          As you know, Corporate Affairs and P&O teams play an important role facilitating
          opportunities for Mars Family Members to participate in site events and relevant
          business-led events.
        </p>
        <p>
          We use the <b>Touch</b>{" "}
          <a
            href="https://touchapp.mars.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://touchapp.mars.com/
          </a>{" "}
          tool to request, coordinate, and document events for which a Family Member&apos;s
          attendance or participation would be valuable to your Associates. These may include
          milestone anniversaries, groundbreaking ceremonies, Associate/leadership meetings, site
          visits, and special Segment/functional/regional meetings.
        </p>
        <p>
          Please review the brief information about the{" "}
          <b>Touch</b> tool and process below and contact{" "}
          <b>Linda.Liszkiewicz@effem.com</b> with any questions.
        </p>
        <p>To manage busy travel schedules, we recommend you input your request:</p>
        <h6 style={boldText}>
          <span style={purpleText}>six months in advance</span> - but -{" "}
          <span style={greenText}>the sooner, the better!</span>
        </h6>
        <p>
          Before planning your event, consult the Corporate Calendar{" "}
          <a
            href="https://calendar.mars.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://calendar.mars.com/
          </a>
          . If the date is flexible and you would like to prioritize it around a Family Member&apos;s
          availability, please note that in the request.
        </p>
        <h6 style={sectionHeader}>A Family Member has accepted my visit! Now what?</h6>
        <p>
          <b>1. Before the visit</b>
          <br />
          If a Family Member has accepted the request in TOUCH, you are asked to send event
          details including an agenda, description of the format for the engagement, audience,
          speaking points, and high-level information for your site. A template is available upon
          request for this information from <b>alex.west@effem.com</b> who can work with
          you to make the most of a Family Member&apos;s engagement.
        </p>
        <p>
          Logistical information should also be provided, including venue, hotel accommodations,
          ground transportation, etc. to <b>Linda.Liszkiewicz@effem.com</b> and uploaded in
          TOUCH.
        </p>
        <p>
          <b>2. During the visit</b>
          <br />
          The requestor needs to ensure that Family Members are comfortable with the logistics and
          well-prepared for the event. It is recommended that a single, local POC is available and
          present. Photography should be unintrusive and generally for internal use only.
        </p>
        <p>
          <b>3. After the visit</b>
          <br />
          Once the visit has concluded, the requestor is to upload photos and an event summary to
          the TOUCH system within 2-3 days after the visit. Don’t worry, you will get an email
          reminder from TOUCH to do so. In addition, you are encouraged to share the event with
          Associates and asked to work with Alex West on internal or external
          communications featuring the Mars Family.
        </p>
        <div style={checkboxContainer}>
          <input
            className="form-check-input"
            type="checkbox"
            checked={isCheckboxChecked}
            style={{ borderColor: "#00008b" }}
            onChange={handleCheckboxChange}
          />
          <label className="form-check-label" htmlFor="flexCheckDefault">
            Stop showing me this message when starting the application
          </label>
        </div>
        <div style={textCenter}>
          <button style={buttonStyles} onClick={handleStartToMeet}>
            START TO MEET
          </button>
        </div>
      </div>
    </Popup>
  );
};

export default InformationPopup;
